import axiosInstance from "@/api/axiosInstance";
import {
  FetchEventAttendancesRequest,
  FetchEventAttendancesResponse,
  AttendanceGridResponse,
} from "./types";

export const fetchEventAttendances = async (
  requestData: FetchEventAttendancesRequest,
): Promise<FetchEventAttendancesResponse> => {
  const url = `/api/private/event-sessions/${requestData.uuid}/attendances`;

  const response = await axiosInstance.get<FetchEventAttendancesResponse>(url, {
    params: {
      searchTerm: requestData.searchTerm,
      sortOrder: requestData.sortOrder,
      sortBy: requestData.sortBy,
      page: requestData.page,
      pageSize: requestData.pageSize,
      status: requestData.status,
    },
  });

  return response.data;
};

export const fetchAttendanceGrid = async (
  requestData: FetchEventAttendancesRequest,
): Promise<AttendanceGridResponse> => {
  const url = `/api/private/event-sessions/${requestData.uuid}/attendance-grid`;

  const response = await axiosInstance.get<AttendanceGridResponse>(url, {
    params: {
      status: requestData.status,
    },
  });

  return response.data;
};
